export default __webpack_public_path__ + "static/media/molecules_slide.2260f033.png";